<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">类型</span>
        <el-radio-group
          style="margin: 0 10px"
          v-model="conditions.type"
        >
          <el-radio :label="null">全部</el-radio>
          <el-radio :label="0">发卡</el-radio>
          <el-radio :label="1">补卡</el-radio>
        </el-radio-group>
        <span class="fonints">时间选择</span>
        <el-date-picker
          v-model="datamsg"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="datachange($event, ['starttime', 'endtime'])"
        >
        </el-date-picker>
        <button class="buttons" @click="selectlist">查询</button>
      </div>
      <div class="componentSty_content_table">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
           height="80%"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column label="发卡时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.cardTime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型">
              <template v-slot="res">
                    <span style="color:orange" v-show="res.row.type==0">发卡</span>
                    <span style="color: #ff4900" v-show="res.row.type==1">补卡</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            @current-change="getlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "会员管理" }, { name: "补卡申请" }],
      conditions: {
        page: 1,
        limit: 20,
        plate: null,
        starttime: "",
        endtime: "",
        type:null
      },
      timeout: null,
      arrlist: [],
      datamsg: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
    const dt = new Date(),
      year = dt.getFullYear(),
      mounth = dt.getMonth(),
      day = dt.getDate();
    this.datamsg = [
      new Date(year, mounth, day, 0, 0),
      new Date(year, mounth, day + 1, 0, 0),
    ];
    this.conditions.starttime=this.mydateFormat(new Date(year, mounth, day, 0, 0),'时分秒');
    this.conditions.endtime=this.mydateFormat(new Date(year, mounth, day+1, 0, 0),'时分秒')
    this.getlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/cardlogs/list",
        "get",
        this.conditions
      );
      console.log(data)
      if(data.code!=0) return this.$message.error(data.msg);
      this.arrlist = data.page;
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getlist();
    },
    datachange(val, arr) {
      val = val || [];
      this.conditions[arr[0]] = val[0];
      this.conditions[arr[1]] = val[1];
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>